module.exports = __webpack_public_path__ + "static/media/photo-register.653008f2.jpeg";